import React, { useState } from 'react';
import { IOrder } from '@/interfaces/order';
import Title from '@/components/title';
import PackingAddPanel from './components/packing-add-panel';
import { ISearchPackingListRes } from '@/interfaces/packingList';
import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { searchpackingLists } from '@/adapters/packingList';
import PackingListViewTable from './components/packing-list-view-table';
import { sumBy } from 'lodash';
import { isManager, isWareHouse } from '@/utils/permissionUtils';
import { Button } from 'antd';

interface IProps {
  data: IOrder;
}

const OrderPackingList = ({ data }: IProps) => {
  const perManager = isManager();
  const perWarehouse = isWareHouse();
  const [create, setCreate] = useState(false);
  const { data: packingLists, refetch } = useQuery<
    AxiosResponse<ISearchPackingListRes>,
    Error
  >({
    queryKey: ['search-packing-list', data],
    queryFn: async () =>
      await searchpackingLists({
        orderId: Number(data?.id),
        pageSize: -1,
        pageStart: 1,
      }),
    enabled: !!data,
  });

  const netWeight = sumBy(data?.orderItems || [], 'quantity');
  const netWeightPackingList = sumBy(
    packingLists?.data?.data || [],
    'netWeight',
  );
  return (
    <div className="flex flex-col gap-3 w-full">
      <Title
        customClassName="text-lg text-blue-700 mt-4"
        customContainerClassName="py-0"
        title={`รายการ`}
      />
      <PackingListViewTable
        orderNetWeight={netWeight}
        data={packingLists?.data?.data || []}
        onDelete={() => refetch()}
      />

      {(perManager || perWarehouse || netWeightPackingList !== netWeight) &&
        create && (
          <PackingAddPanel
            orderItems={data?.orderItems || []}
            orderId={data?.id || 0}
            onAddPackingList={() => {
              refetch();
            }}
          />
        )}
      {(perManager || perWarehouse || netWeightPackingList !== netWeight) && (
        <div className="flex flex-end justify-end">
          {!create ? (
            <Button type="primary" onClick={() => setCreate(!create)}>
              + เพิ่ม Packing List
            </Button>
          ) : (
            <Button type="primary" ghost onClick={() => setCreate(!create)}>
              ปิด
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default OrderPackingList;
